import {Pipe, PipeTransform} from "@angular/core";
import {ComparatorService} from "../../services/comparator-service";

@Pipe({
  name: 'orderByErstellzeitpunkt'
})
export class OrderByErstellzeitpunktPipe implements PipeTransform {

  public constructor(private comperatorService: ComparatorService) {
  }

  transform(array: Array<any>, ascending = true): Array<any> {
    if (ascending) {
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.comperatorService.erstellzeitpunktComparator(item1, item2);
      });
    } else {
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.comperatorService.erstellzeitpunktComparator(item2, item1);
      });
    }
  }

}
